import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "These are the times I love my job",
  "description": "",
  "published": "2009-12-28T00:00:00.000Z",
  "redirect_from": ["/blog/these-are-the-times-i-love-my-job/swizec/1034"],
  "categories": "Computer programming, life, Programming, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I spent five solid hours programming (so far) and didn't write a single line of code, nay, not even a single character. All I did was think with the whiteboard.`}</p>
    <p>{`Eventually covering about 15 square meters of whiteboard in squiggly lines and weird characters and all sorts of stuff that I probably shouldn't explain in too great a detail publicly. Let it suffice to say that I believe to have solved the problem of translating machine vocabulary to personalised user vocabulary.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/IMG00137.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/IMG00137.jpg",
          "alt": "IMG00137",
          "title": "IMG00137"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/IMG00135.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/IMG00135.jpg",
          "alt": "IMG00135",
          "title": "IMG00135"
        }}></img></a><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/IMG00133.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/IMG00133.jpg",
          "alt": "IMG00133",
          "title": "IMG00133"
        }}></img></a></p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://developers.slashdot.org/story/09/12/23/1820214/Why-Coder-Pay-Isnt-Proportional-To-Productivity?from=rss"
        }}>{`Why Coder Pay Isn't Proportional To Productivity`}</a>{` (developers.slashdot.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.marginalrevolution.com/marginalrevolution/2009/12/what-does-programmer-productivity-look-like.html"
        }}>{`What does programmer productivity look like?`}</a>{` (marginalrevolution.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.juanitachronowski.com/jdcblog/?p=2048"
        }}>{`Thinking in Code`}</a>{` (juanitachronowski.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/9e9ff916-994c-4c7e-880d-90febe453b07/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=9e9ff916-994c-4c7e-880d-90febe453b07",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      